import { ModuleWithProviders } from "@angular/core";
import { RouterModule } from "@angular/router";

import { RootComponent } from "./root/root.component";

import { VisaoCidadeComponent } from "./pages/visao-cidade/visao-cidade.component";
import { ClienteMovimentacaoComponent } from "./pages/cliente-movimentacao/cliente-movimentacao.component";
import { CarteiraPedidoComponent } from "./pages/carteira-pedido/carteira-pedido.component";
import { DebitosAbertoComponent } from "./pages/debitos-aberto/debitos-aberto.component";
import { EspelhoPedidoComponent } from "./pages/espelho-pedido/espelho-pedido.component";
import { AcompanharLancamentoSetorComponent } from './pages/acompanhar-lancamento-setor/acompanhar-lancamento-setor.component';
import { CarteiraClientesComponent } from './pages/carteira-clientes/carteira-clientes.component';
import { PrevisaoVendasComponent } from './pages/previsao-vendas/previsao-vendas.component';
import { EspelhoPdfComponent } from "./pages/espelho-pdf/espelho-pdf.component";

import { AuthGuard } from "@core/guards/auth.guard";
import { HistoricoRecepcaoTransmissaoComponent } from "./pages/historico-recepcao-transmissao/historico-recepcao-transmissao.component";
import { LiberarDigitacaoTrcComponent } from "./pages/liberar-digitacao-trc/liberar-digitacao-trc.component";
import { RelatorioVendasComponent } from "./pages/relatorio-vendas/relatorio-vendas.component";

export const routing: ModuleWithProviders = RouterModule.forChild([
  {
    path: "clientes",
    component: RootComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        component: PrevisaoVendasComponent,

      },
      { path: "home", component: PrevisaoVendasComponent },
      { path: "visao-cidade", component: VisaoCidadeComponent },
      { path: "acompanhar-lancamento-setor", component: AcompanharLancamentoSetorComponent },
      { path: "cliente-movimentacao", component: ClienteMovimentacaoComponent },
      { path: "carteira-pedido", component: CarteiraPedidoComponent },
      { path: "debitos-aberto", component: DebitosAbertoComponent },
      { path: "espelho-pedido", component: EspelhoPedidoComponent },
      { path: "carteira-clientes", component: CarteiraClientesComponent },
      { path: "espelho-pdf", component: EspelhoPdfComponent },
      { path: "historico-recepcao-transmissao", component: HistoricoRecepcaoTransmissaoComponent },
      { path: "liberar-digitacao-trc", component: LiberarDigitacaoTrcComponent },
      { path: "relatorio-vendas", component: RelatorioVendasComponent },
    ]
  }
]);
